import React from "react";
import { CategoryContainer } from "../../components/CategoryContainer";
import { Typography } from "@mui/material";
import { TextFieldRHF } from "../../components/RHFWrappedComponents";
import { AddAnother } from "../../components/AddAnother";
import { useFormContext } from "react-hook-form";

export function CollegeChoices() {
  const { getValues } = useFormContext();

  return (
    <CategoryContainer title="College Choices">
      <Typography variant="body2">
        Future college choice or if currently attending provide current college
        details.
      </Typography>
      <AddAnother
        arrayName="collegeInfo.schoolAndMajorChoices"
        defaultValue={{
          schoolName: "",
          majorName: "",
        }}
        renderForm={(i) => (
          <>
            <TextFieldRHF
              name={`collegeInfo.schoolAndMajorChoices.${i}.schoolName`}
              textFieldLabel={"School Name"}
              rules={{
                validate: {
                  ifMajorSet: (v: string): boolean | string => {
                    const entity = getValues(
                      `collegeInfo.schoolAndMajorChoices.${i}.majorName`
                    );
                    if (!entity) {
                      // Major is not set so any value in this field is good
                      return true;
                    }
                    return v !== null && v.length > 0
                      ? true
                      : "School Name is required";
                  },
                },
              }}
            />
            <TextFieldRHF
              name={`collegeInfo.schoolAndMajorChoices.${i}.majorName`}
              textFieldLabel={"Major Name"}
              rules={{
                validate: {
                  ifSchoolSet: (v: string): boolean | string => {
                    const entity = getValues(
                      `collegeInfo.schoolAndMajorChoices.${i}.schoolName`
                    );
                    if (!entity) {
                      // School is not set so any value in this field is good
                      return true;
                    }
                    return v !== null && v.length > 0
                      ? true
                      : "Major Name is required";
                  },
                },
              }}
            />
          </>
        )}
      />
    </CategoryContainer>
  );
}
